<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="page-header">
		<h4 class="page-title">
			<span *ngIf="project?.id">
				{{'labels.project-edit' | translate}} {{project.name}}
			</span>
			<span *ngIf="!project?.id">{{'labels.project-create' | translate}}</span>
		</h4>

	</div>
	<div class="card">
		<div
			class="card-body"
			ngbAutofocus>
			<div
				class="row"
				*ngIf="loading">
				<div class="col text-center">
					<app-loader [material]="false"></app-loader>
				</div>
			</div>

			<div
				class="row"
				*ngIf="errormessage">

				<div class="col-md-12 alert alert-danger">{{errormessage}}</div>
			</div>
			<div
				class="row"
				*ngIf="!loading && projectdata">
				<!-- stateoftheart -->
				<hr class="col mt-3">
				<div class="form-group col-md-12 mt-1">
					<label>
						{{ 'project.stateoftheart' | translate }}*
					</label>
					<quill-editor
						name="stateoftheart"
						[required]="true"
						[(ngModel)]="projectdata.jsondata['stateoftheart']"
						placeholder
						#stateoftheart="ngModel"
						[ngClass]="editForm.submitted && stateoftheart.invalid ? 'is-invalid' : ''">
					</quill-editor>

					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && stateoftheart.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
				<!-- projectgoal -->
				<hr class="col mt-3">
				<div class="form-group col-md-12 mt-1">
					<label>
						{{ 'project.projectgoal' | translate }}*
					</label>
					<quill-editor
						name="projectgoalt"
						[required]="true"
						[(ngModel)]="projectdata.jsondata['projectgoal']"
						placeholder
						#projectgoal="ngModel"
						[ngClass]="editForm.submitted && projectgoal.invalid ? 'is-invalid' : ''">
					</quill-editor>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && projectgoal.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
				<!-- marketprospect -->
				<hr class="col mt-3">
				<div class="form-group col-md-12 mt-1">
					<label>
						{{ 'project.marketprospect' | translate }}*
					</label>
					<quill-editor
						name="marketprospect"
						[required]="true"
						[(ngModel)]="projectdata.jsondata['marketprospect']"
						placeholder
						#marketprospect="ngModel"
						[ngClass]="editForm.submitted && marketprospect.invalid ? 'is-invalid' : ''">
					</quill-editor>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && marketprospect.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
				<!-- corporateuse -->
				<hr class="col mt-3">
				<div class="form-group col-md-12 mt-1">
					<label>
						{{ 'project.corporateuse' | translate }}*
					</label>
					<quill-editor
						name="corporateuse"
						[required]="true"
						[(ngModel)]="projectdata.jsondata['corporateuse']"
						placeholder
						#corporateuse="ngModel"
						[ngClass]="editForm.submitted && corporateuse.invalid ? 'is-invalid' : ''">
					</quill-editor>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && corporateuse.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
				<!-- groupskills -->
				<hr class="col mt-3">
				<div class="form-group col-md-12 mt-1">
					<label>
						{{ 'project.groupskills' | translate }}*
					</label>
					<quill-editor
						name="groupskills"
						[required]="true"
						[(ngModel)]="projectdata.jsondata['groupskills']"
						placeholder
						#groupskills="ngModel"
						[ngClass]="editForm.submitted && groupskills.invalid ? 'is-invalid' : ''">
					</quill-editor>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && groupskills.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
				<!-- sustainability -->
				<hr class="col mt-3">
				<div class="form-group col-md-12 mt-1">
					<label>
						{{ 'project.sustainability' | translate }}*
					</label>
					<quill-editor
						name="sustainability"
						[required]="true"
						[(ngModel)]="projectdata.jsondata['sustainability']"
						placeholder
						#sustainability="ngModel"
						[ngClass]="editForm.submitted && sustainability.invalid ? 'is-invalid' : ''">
					</quill-editor>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && sustainability.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>

				<!-- consistency -->
				<hr class="col mt-3">
				<div class="form-group col-md-12 mt-1">
					<label>
						{{ 'project.consistency.title' | translate }}*
					</label>
					<ng-template
						ngFor
						let-k
						[ngForOf]="consistencykeys">
						<div class="col-md-12">
							<input
								type="checkbox"
								class="form-check-input"
								name="consistency"
								[checked]="consistency[k]"
								(change)="consistency[k] = !consistency[k]">
							<label class="form-check-label">
								{{'project.consistency.' + k | translate}}
							</label>
						</div>

					</ng-template>

				</div>

				<!-- objective -->
				<hr class="col mt-3">
				<div class="form-group col-md-12 mt-1">
					<label>
						{{ 'project.objective.title' | translate }}*
					</label>
					<ng-template
						ngFor
						let-k
						[ngForOf]="objectivekeys">
						<div class="col-md-12">
							<input
								type="checkbox"
								class="form-check-input"
								name="objective"
								[checked]="objective[k]"
								(change)="objective[k] = !objective[k]">
							<label class="form-check-label">
								{{'project.objective.' + k | translate}}
							</label>
						</div>

					</ng-template>
					<div class="col-md-12"></div>
					<textarea
						*ngIf="objective.other"
						[disabled]="!project.isDraft"
						[(ngModel)]="objective.othertext"
						#othertext="ngModel"
						name="othertext"
						required
						type="text"
						class="form-control"
						id="othertext"
						placeholder="{{ 'project.objective.othertext' | translate }}"
						[ngClass]="{'is-invalid': editForm.submitted && !objective.othertext}"></textarea>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && !objective.othertext">
						{{'errors.required' | translate}}
					</div>

				</div>
			</div>
		</div>
		<div class="card-footer">

			<button
				type="button"
				class="btn btn-secondary"
				(click)="dismiss()">
				{{'labels.cancel' | translate}}
			</button>
			<button
				type="submit"
				class="btn btn-primary float-right">
				{{'labels.save' | translate}}
			</button>
		</div>
	</div>

</form>
